import React from 'react'
import algoliasearch from 'algoliasearch'
import {InstantSearch, Configure} from 'react-instantsearch-dom'

import {useGatsbyData} from '../../context/gatsbyDataContext'
import AutoComplete from './AutoComplete'

const searchClient = algoliasearch(
  'SCVFWSL9QV',
  '6e876d619ad670e9afe9a39d5690ebf6',
)

function compineFilters(filters) {
  return Object.entries(filters)
    .map(([key, value]) => `${key}:${JSON.stringify(value)}`)
    .join(' AND ')
}

function AlgoliaSearchWrapper() {
  const {locale, release: defaultRelease} = useGatsbyData().pageContext
  const [release, setRelease] = React.useState(defaultRelease)

  return (
    <div style={{width: '100%'}}>
      <InstantSearch
        searchClient={searchClient}
        indexName="prod_docs4_archive_index"
        onSearchStateChange={() => {
          if (window.ga) {
            window.ga(
              'set',
              'page',
              window.location.pathname + window.location.search,
            )
            window.ga('send', 'pageView')
          }
        }}
      >
        <Configure
          filters={compineFilters({locale, release})}
          attributesToHighlight={['title', 'header']}
          attributesToSnippet={['text:15']}
          hitsPerPage={10}
        />
        <AutoComplete release={release} setRelease={setRelease} />
      </InstantSearch>
    </div>
  )
}

export default AlgoliaSearchWrapper
